/**
 * Servidores MCP — landing grid. One small card per MCP server (reuses
 * EntityCard, the same card used for agents), each linking to its own
 * detail view at /organization/mcp/:serverId.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Tag, Spin } from 'antd';
import { ApiOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import AppPageLayout from './common/AppPageLayout';
import PageHeader from './common/PageHeader';
import EntityCard from './common/EntityCard';
import { useAdminGuard } from '../hooks/useAdminGuard';
import { MCP_SERVERS } from '../types/mcp';

const McpServersListPage: React.FC = () => {
  const { loading } = useAdminGuard();
  const navigate = useNavigate();

  if (loading) {
    return (
      <AppPageLayout>
        <div style={{ display: 'flex', justifyContent: 'center', padding: 80 }}>
          <Spin size="large" />
        </div>
      </AppPageLayout>
    );
  }

  return (
    <AppPageLayout>
      <PageHeader
        icon={<ApiOutlined />}
        title="Servidores MCP"
        subtitle="Conectores MCP que la organización expone a Claude, con login Google por empleado."
      />

      <Row gutter={[24, 24]}>
        {MCP_SERVERS.map((server) => (
          <Col xs={24} sm={12} md={8} lg={6} key={server.id}>
            <EntityCard
              icon={<ApiOutlined />}
              title={server.name}
              subtitle={server.id}
              description={server.description}
              onClick={() => navigate(`/organization/mcp/${server.id}`)}
              tags={
                <Tag
                  icon={<SafetyCertificateOutlined />}
                  color="green"
                  style={{ margin: 0, fontSize: 10, padding: '0 4px', lineHeight: '16px' }}
                >
                  Solo lectura
                </Tag>
              }
            />
          </Col>
        ))}
      </Row>
    </AppPageLayout>
  );
};

export default McpServersListPage;
